import { render } from "./SearchModal.vue?vue&type=template&id=560cb428&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"

import "./SearchModal.vue?vue&type=style&index=0&id=560cb428&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560cb428"]])

export default __exports__